import script from "./SearchBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchBox.vue?vue&type=script&setup=true&lang=ts"

import "./SearchBox.vue?vue&type=style&index=0&id=1f9fc6a4&lang=css"

const __exports__ = script;

export default __exports__